import idb from 'idb'
import RemoteLogger from 'common/remoteLogger';

const DB_NAME = "weather-db"
const STORE_NAME = "weather-store"

class CacheStore {
    constructor() {
        this.storeDb = idb.open(DB_NAME, 1, upgradeDB => {
            upgradeDB.createObjectStore(STORE_NAME);
        });
    }

    set(key, val) {
        return this.storeDb.then(db => {
            try {
                const tx = db.transaction(STORE_NAME, 'readwrite');
                tx.objectStore(STORE_NAME).put(val, key);
                return tx.complete;
            } catch (err) {
                RemoteLogger.log("failed to add entry to idb: " + err);
                return null;
            }
        });
    }

    get(key) {
        return this.storeDb.then(db => {
            try {
                return db.transaction(STORE_NAME).objectStore(STORE_NAME).get(key)
            } catch (err) {
                RemoteLogger.log("failed to get entry from idb: " + err);
                return null;
            }
        });
    }
}

let instance = new CacheStore()
export default instance;


// WEBPACK FOOTER //
// ./src/stores/cacheStore.js